import { useEffect, useState } from "react";
import { customSvg } from "../constants/customSvg";

function RenderSvg({ config, svgType, id }) {
  const [height, setHeight] = useState(window.innerHeight);
  const [width, setWidth] = useState(window.innerWidth);
  const [isMobile, setIsMobile] = useState(width <= 980);

  useEffect(() => {
    setHeight(height * 0.18);
  }, []);
  const colorCode = {
    1: {
      color: config?.branding?.accentColor,
    },
    2: {
      color:
        "color-mix(in srgb, " + config?.branding?.accentColor + " 10%, white)",
    },
    3: {
      color:
        "color-mix(in srgb, " + config?.branding?.accentColor + " 30%, white)",
    },
    4: {
      color:
        "color-mix(in srgb, " + config?.branding?.accentColor + " 40%, white)",
    },
    5: {
      color:
        "color-mix(in srgb, " + config?.branding?.accentColor + " 50%, white)",
    },
    6: {
      color:
        "color-mix(in srgb, " + config?.branding?.accentColor + " 60%, white)",
    },
  };

  useEffect(() => {
    for (let i = 1; i <= 6; i++) {
      const elements = document.getElementsByClassName(`shade${i}`);
      for (let element of elements) {
        if (element) {
          if (element.getAttribute("fill")) {
            element.style.fill = colorCode[i]?.color;
          }
          if (element.getAttribute("stroke")) {
            element.style.stroke = colorCode[i]?.color;
          }
        }
      }
    }
  }, [config?.branding?.accentColor]);

  return (
    <div
      dangerouslySetInnerHTML={{ __html: customSvg[svgType] }}
      style={{
        height: isMobile ? height : 180,
        width: isMobile ? height : 180,
      }}
      className={"flex md:w-[246px] md:h-[226px] justify-center items-center "}
    />
  );
}

export default RenderSvg;
